export interface State {
  /**
   * Represents what stage in the deployment process the user is at
   *
   * Set to `undefined` when the user has not started the deployment process
   */
  stage?: 'packages' | 'resources' | 'evaluation'
}
export namespace State {
  export const INITIAL: Readonly<State> = {}
}
